import { getSafeAreaPaddings } from "@clipboard-health/ui-theme";
import { Box } from "@mui/material";
import { useRef } from "react";

import { LoadingButton } from "../components/LoadingButton";
import { PageWrapper } from "../components/PageWrapper";
import { StickyFooter } from "../components/StickyFooter";
import { StickyScrollPageHeader } from "../components/StickyScrollPageHeader";

interface BackgroundCheckPageContainerPropsBase {
  children: React.ReactNode;
  hideHeader?: boolean;
  isLoading?: boolean;
  navigateBack?: () => void;
}

type BackgroundCheckPageContainerProps =
  | (BackgroundCheckPageContainerPropsBase & {
      hideFooter: true;
      buttonText?: never;
      onButtonClick?: never;
    })
  | (BackgroundCheckPageContainerPropsBase & {
      hideFooter?: false;
      buttonText: string;
      onButtonClick: () => void;
    });

export function BackgroundCheckPageContainer(props: BackgroundCheckPageContainerProps) {
  const {
    children,
    buttonText,
    onButtonClick,
    hideHeader = false,
    isLoading = false,
    hideFooter = false,
    navigateBack,
  } = props;
  const scrollRef = useRef<HTMLDivElement>(null);

  return (
    <PageWrapper
      variant="tertiary"
      sx={(theme) => ({
        ...getSafeAreaPaddings({
          bottom: true,
          fallbackBottom: theme.spacing(3),
        }),
      })}
    >
      <StickyScrollPageHeader
        shouldWrapTitle
        title=""
        headerVariant="tertiary"
        scrollContainerRef={scrollRef}
        hideBackButton={hideHeader}
        navigateBack={navigateBack}
      />
      <Box
        ref={scrollRef}
        sx={{
          flex: 1,
          overflow: "auto",
          display: "flex",
          flexDirection: "column",
          px: 7,
          pt: hideHeader ? 8 : 0,
        }}
      >
        {children}
      </Box>
      {!hideFooter && (
        <StickyFooter>
          <LoadingButton
            fullWidth
            isLoading={isLoading}
            size="large"
            variant="contained"
            disabled={isLoading}
            onClick={onButtonClick}
          >
            {buttonText}
          </LoadingButton>
        </StickyFooter>
      )}
    </PageWrapper>
  );
}
